import React from "react";

import { MenuItem, Select } from "@mui/material";

const itemStyles = {
  item: {
    backgroundColor: "#EFEFEF",
    margin: "2px",
    color: "#888",
    padding: "5px",
    fontSize: "0.7em",
    "&:hover": {
      backgroundColor: "#888",
      color: "#EFEFEF",
    },
    cursor: "pointer",
  },
  selected: (theme) => ({
    backgroundColor: `${theme.palette.brand?.blue} !important`,
    color: "#EFEFEF !important",
    "&:hover": {
      backgroundColor: `${theme.palette.brand?.blue} !important`,
      color: "#EFEFEF !important",
    },
  }),
  projection: {
    backgroundColor: "#ff9c47",
    borderStyle: "dashed",
    borderWidth: "2px",
    borderColor: "lightgray",
    "&:hover": {
      backgroundColor: "#ab6d38",
      color: "#EFEFEF",
    },
  },
  selectedProjection: {
    backgroundColor: "#ff7600 !important",
    color: "#EFEFEF !important",
    "&:hover": {
      backgroundColor: "#ff7600 !important",
      color: "#EFEFEF !important",
    },
  },
  unused: {
    backgroundColor: "#ffffff",
    color: "#999",
    "&:hover": {
      backgroundColor: "#ffffff",
      color: "#999",
    },
    cursor: "not-allowed ",
  },
};

const getMenuSX = ({ selected, projection, used }) => {
  return [
    itemStyles.item,
    selected && projection && itemStyles.selectedProjection,
    selected && !projection && itemStyles.selected,
    projection && itemStyles.projection,
    !used && itemStyles.unused,
  ];
};

/**
 * Mobile timeline renderer using a MUI Select.
 * Stateless: renders options and calls onPickOriginalIndex.
 */
function MobileTimelineSelect({
  sliderItems,
  originalItems,
  displaySelected,
  isChangeMode,
  onPickOriginalIndex,
}) {
  return (
    <Select
      id="klimaSliderTimeline"
      variant="outlined"
      style={{ height: 35 }}
      value={displaySelected}
      onChange={(event) => {
        const {
          target: { value },
        } = event;
        if (
          !isNaN(value) &&
          value >= 0 &&
          value < (originalItems || []).length &&
          originalItems[value].used
        ) {
          onPickOriginalIndex(value);
        }
      }}
      fullWidth
    >
      {sliderItems.map((item) => {
        const originalIndex = originalItems.indexOf(item);
        const { label = item, projection = false, used } = item;

        const available = used && !(isChangeMode && !projection);
        const isSelected = originalIndex === displaySelected;

        return (
          <MenuItem
            key={`${label};${originalIndex}`}
            sx={getMenuSX({
              selected: isSelected,
              used: available,
              projection,
            })}
            value={originalIndex}
            selected={isSelected}
            disabled={!available}
          >
            <div dangerouslySetInnerHTML={{ __html: label }} />
          </MenuItem>
        );
      })}
    </Select>
  );
}

export default MobileTimelineSelect;
